import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_Locker } from "../../shared/data.service";
import { LockerUpdateRequest } from "../../shared/LockerUpdateRequest";

@Component({
	selector: "app-edit-locker",
	templateUrl: "./edit-locker.component.html",
	styleUrls: ["./edit-locker.component.css"],
})
export class EditLockerComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private LockerService: DataService_Locker
	) {}

	ngOnInit(): void {
		this.SelectedLocker = this.dialogConfig.data.SelectedLocker;

		// console.log("Selected Locker");
		// console.log(this.SelectedLocker);

		this.LockerNum = this.SelectedLocker.LockerNum;
		this.AssignedToDesc = this.SelectedLocker.AssignedToDesc;
		this.AssignedDTDesc = this.SelectedLocker.AssignedDTDesc;
		this.Assignable = this.SelectedLocker.Assignable;
		this.AssignedComments = this.SelectedLocker.AssignedComments;
		this.Comments = this.SelectedLocker.Comment;

		this.CanMakeAssignable = !this.SelectedLocker.AlreadyAssigned;
	}

	////////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////////

	SelectedLocker: any;

	LockerNum: any = "";
	AssignedToDesc: any = "";
	AssignedDTDesc: any = "";
	AssignedComments: any = "";
	Assignable: any = false;
	Comments: any;
	CanMakeAssignable: any = false;

	processing: any = false;
	errorMessage: any = "";

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////////////
	onEdit() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		if (this.LockerNum == "") {
			this.errorMessage = "Enter a locker number";
			return;
		}

		//
		// Create Request
		//

		this.processing = true;

		let parms: LockerUpdateRequest = {
			LockerID: this.SelectedLocker.LockerID,
			LockerNum: this.LockerNum,
			Assignable: this.Assignable == true ? 1 : 0,
			AssignedComments: this.AssignedComments,
			Comments: this.Comments,
		};

		//
		// Call SP
		//
		var result = this.LockerService.LockerUpdate(parms);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (this.AllClear(response)) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Locker was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Locker",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.processing == true;
	}

	CanEditAssignedComments() {
		return this.SelectedLocker.AlreadyAssigned == true;
	}

	AllClear(lstResp) {
		var ans = true;

		for (var z = 0; z < lstResp.length; z++) {
			var next = lstResp[z];

			if (next != "") {
				// Error message found
				ans = false;
				break;
			}
		}

		return ans;
	}

	////////////////////////////////////////////////////////////////////////
}
